import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import styles from "./styles.scss";

const minutesOptions = [0, 15, 30, 45];

function DeltaSelect({
  delta,
  timeUnit,
  offset,
  select,
  selectTimeUnit,
}: Props) {
  const { t } = useTranslation();
  const hours = timeUnit === "HOUR" ? Math.floor(delta) : 0;
  const minutes = timeUnit === "HOUR" ? Math.round((delta - hours) * 60) : 0;

  return (
    <div className={styles.deltaSelect}>
      {timeUnit === "DAY" ? (
        <input
          type="number"
          min={0}
          className={styles.valueInput}
          value={delta}
          onChange={({ target }) => select(parseInt(target.value), offset)}
        />
      ) : (
        <div className={styles.hourValue}>
          <input
            type="number"
            min={0}
            className={styles.valueInput}
            value={hours}
            onChange={({ target }) =>
              select(parseInt(target.value) + minutes / 60, offset)
            }
          />
          <SelectList listClassName={styles.listRoot}>
            {({ isOpen, select: s }) => ({
              input: (
                <div
                  className={classNames(styles.input, {
                    [styles.opened]: isOpen,
                  })}
                >
                  <p className={styles.name}>
                    {String(minutes).padStart(2, "0")}
                  </p>
                  <ToggleArrowIcon className={styles.icon} />
                </div>
              ),
              list: (
                <div className={styles.list}>
                  {minutesOptions.map((item) => (
                    <div
                      key={item}
                      className={classNames(styles.delta, {
                        [styles.selected]: item === minutes,
                      })}
                      onClick={() => s(select(hours + item / 60, offset))}
                    >
                      <p className={styles.name}>
                        {String(item).padStart(2, "0")}
                      </p>
                    </div>
                  ))}
                </div>
              ),
            })}
          </SelectList>
        </div>
      )}
      <SelectList listClassName={styles.listRoot}>
        {({ isOpen, select: s }) => ({
          input: (
            <div
              className={classNames(styles.input, { [styles.opened]: isOpen })}
            >
              <p className={styles.name}>
                {t(
                  `constraintTypeForm.deltas.${timeUnit === "DAY" ? "days" : "hours"}`,
                )}
              </p>
              <ToggleArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.list}>
              {(["DAY", "HOUR"] as const).map((item) => (
                <div
                  key={item}
                  className={classNames(styles.delta, {
                    [styles.selected]: item === timeUnit,
                  })}
                  onClick={() => s(selectTimeUnit(item))}
                >
                  <p className={styles.name}>
                    {t(
                      `constraintTypeForm.deltas.${item === "DAY" ? "days" : "hours"}`,
                    )}
                  </p>
                </div>
              ))}
            </div>
          ),
        })}
      </SelectList>
      <SelectList listClassName={styles.listRoot}>
        {({ isOpen, select: s }) => ({
          input: (
            <div
              className={classNames(styles.input, { [styles.opened]: isOpen })}
            >
              <p className={styles.name}>
                {t(`constraintTypeForm.deltas.${offset}`)}
              </p>
              <ToggleArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.list}>
              {["before", "after"].map((item) => (
                <div
                  key={item}
                  className={classNames(styles.delta, {
                    [styles.selected]: item === offset,
                  })}
                  onClick={() => s(select(delta, item as "before" | "after"))}
                >
                  <p className={styles.name}>
                    {t(`constraintTypeForm.deltas.${item}`)}
                  </p>
                </div>
              ))}
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { DeltaSelect };
